import type { GameDescriptor } from '../game-registry.js';
import { CardsScene } from '../scenes/CardsScene.js';

export const cardsDescriptor: GameDescriptor = { code: 'cards', scene: CardsScene, supportsAuto: true };
